<tt-page *ngIf="!!edit">
    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-input *ngIf="collectionKeyno === '0'" ttLabel="collection_keyno" [(ttModel)]="edit.collection_keyno"></tt-input>
        <tt-input *ngIf="collectionKeyno !== '0'" ttLabel="collection_keyno" [ttModel]="edit.collection_keyno" ttReadonly></tt-input>
        <tt-input ttLabel="collection_name" [(ttModel)]="edit.collection_name" ttRequired></tt-input>
        <tt-input ttLabel="collection_short_description" [(ttModel)]="edit.collection_short_description"></tt-input>
        <tt-date ttLabel="valid_from_date" [(ttModel)]="edit.valid_from_date"></tt-date>
        <tt-date ttLabel="valid_to_date" [(ttModel)]="edit.valid_to_date"></tt-date>
        <tt-date ttLabel="price_valid_from_date" [(ttModel)]="edit.price_valid_from_date"></tt-date>
        <tt-checkbox ttLabel="isactive" [(ttModel)]="edit.isactive"></tt-checkbox>
        <tt-checkbox ttLabel="active_preorder" [(ttModel)]="edit.active_preorder"></tt-checkbox>
        <tt-checkbox ttLabel="publish_web" [(ttModel)]="edit.publish_web"></tt-checkbox>
        <tt-date ttLabel="web_date" [(ttModel)]="edit.web_date"></tt-date>
        <tt-input ttLabel="catalogue_name" [(ttModel)]="edit.catalogue_name"></tt-input>
        <tt-date ttLabel="preorder_from_date" [(ttModel)]="edit.preorder_from_date"></tt-date>
        <tt-date ttLabel="preorder_to_date" [(ttModel)]="edit.preorder_to_date"></tt-date>
        <tt-input ttLabel="seasonyear_id" [(ttModel)]="edit.seasonyear_id"></tt-input>
        <tt-button-save ttText="collection_save" (ttClick)="saveChanges()" [ttLoading]="saving"></tt-button-save>
    </tt-card>
</tt-page>
